module.exports = __webpack_public_path__ + "images/active-left.8d500ac0b3af70420679028d2ea556ac.png";